import React from 'react';

import Person from '@material-ui/icons/Person';

const UserDefaultIcon = () => <Person style={{color: '#FFF'}} />;

export default UserDefaultIcon;
